import { render, staticRenderFns } from "./progress-ring.vue?vue&type=template&id=60595b17&"
import script from "./progress-ring.vue?vue&type=script&lang=js&"
export * from "./progress-ring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "progress-ring.vue"
export default component.exports